const performanceDashboard = {
  title: 'Leistungs-Dashboard',
  subTitle: 'Übersicht über die wichtigsten Betriebskennzahlen',
  supplierSelector: {
    label: 'Anbieteren auswählen:',
  },
  acceptDeclineTripsPie: {
    title: 'Fahrten annehmen/ablehnen',
    pies: {
      accept: 'Akzeptieren',
      decline: 'Ablehnen',
    },
  },
  assignmentTypePie: {
    title: 'Zuweisungstyp',
    pies: {
      manual: 'Manuell',
      automated: 'Automatisiert',
    },
  },
  coverageCapacityChart: {
    title: 'Abdeckungskapazität',
    bars: {
      capacity: 'Kapazität',
    },
  },
  fleetAcceptanceChart: {
    title: 'Flottenabnahme',
    bars: {
      acceptance: 'Abnahme',
    },
  },
  noShowCancelationChart: {
    title: 'No-Show- und Stornierungsraten',
    bars: {
      noShow: 'No-Show',
      cancelation: 'Stornierung',
    },
  },
  onTimePerformanceChart: {
    title: 'Pünktlichkeit',
    bars: {
      onTime: 'Pünktlich',
    },
  },
  topFleetsByTripsChart: {
    title: 'Top 10 Fleets by Trips',
    bars: {
      trips: 'Fahrten',
    },
  },
  activeDriversByHourChart: {
    title: 'Top 10 Drivers by Trips',
    bars: {
      drivers: 'Fahrer',
    },
  },
};

export default performanceDashboard;
